'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _aphrodite = require('aphrodite');

var _localizer = require('../util/localizer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = _aphrodite.StyleSheet.create({
	errorMessage: {
		height: 0,
		transition: 'all 0.25s ease-in-out'
	},

	errorShown: {
		height: '100%'
	}
});

/**
 * CEP component for Brazil
 */
var Cpf = _react2.default.createClass({
	displayName: 'Cpf',

	propTypes: {
		handleChange: _propTypes2.default.func,
		handleBlur: _propTypes2.default.func,
		handleFocus: _propTypes2.default.func,
		errorMessageCode: _propTypes2.default.string,
		label: _propTypes2.default.string,
		required: _propTypes2.default.bool,
		value: _propTypes2.default.string,
		warnings: _propTypes2.default.object,
		showError: _propTypes2.default.bool,
		country: _propTypes2.default.string
	},

	getInitialState: function getInitialState() {
		var _props$country = this.props.country,
		    country = _props$country === undefined ? 'US' : _props$country;

		var countryInfo = (0, _localizer.getCountryInfo)(country);
		var state = {
			showGuestCPF: countryInfo.showGuestCPF || false
		};

		if (this.props.errorMessageCode) {
			state = _extends({}, state, {
				showError: true,
				errorMessage: this.props.warnings[this.props.errorMessageCode]
			});
		}
		return state;
	},
	getDefaultProps: function getDefaultProps() {
		return {
			handleChange: function handleChange() {},
			handleFocus: function handleFocus() {},
			handleBlur: function handleBlur() {},
			showRequiredError: false,
			errorMessage: ''
		};
	},
	componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		if (nextProps.errorMessageCode) {
			this.setState({
				showError: true,
				errorMessage: this.props.warnings[nextProps.errorMessageCode]
			});
		}
	},
	handleChange: function handleChange(input) {
		var formattedCpf = this.getFormattedCpf(input);
		this.setState({
			value: formattedCpf
		});
		this.props.handleChange(formattedCpf);
		return formattedCpf;
	},
	handleBlur: function handleBlur() {
		this.validateAndShowError();
		this.props.handleBlur();
	},
	handleFocus: function handleFocus() {
		this.setState({
			showError: false
		});
		this.props.handleFocus();
	},
	getErrorMessage: function getErrorMessage() {
		if (this.state.showError) {
			return this.state.errorMessage;
		}

		return '';
	},
	getFormattedCpf: function getFormattedCpf(cpf) {
		var digitsOnly = cpf.replace(/\D/g, '');
		var firstElevelDigitsOfCpf = digitsOnly.substring(0, 11);

		var formattedCpf = firstElevelDigitsOfCpf.substring(0, 3);
		if (firstElevelDigitsOfCpf.length > 3) {
			formattedCpf += '.';
		} else {
			return formattedCpf;
		}
		formattedCpf += firstElevelDigitsOfCpf.substring(3, 6);
		if (firstElevelDigitsOfCpf.length > 6) {
			formattedCpf += '.';
		} else {
			return formattedCpf;
		}
		formattedCpf += firstElevelDigitsOfCpf.substring(6, 9);
		if (firstElevelDigitsOfCpf.length > 9) {
			formattedCpf += '-';
		} else {
			return formattedCpf;
		}
		formattedCpf += firstElevelDigitsOfCpf.substring(9, 11);

		return formattedCpf;
	},


	/**
  * Validates and displays error
  * @return {Boolean} True when validation passes, false otherwise
  */
	validateAndShowError: function validateAndShowError() {
		if (!this.state.showGuestCPF) {
			return true;
		}

		// Check that CPF is present
		if (!this.state.value) {
			this.setState({
				showError: true,
				errorMessage: this.props.warnings._REQUIRED_CPF
			});
			return false;
		}

		if (!this.isCpfValid()) {
			this.setState({
				showError: true,
				errorMessage: this.props.warnings._INVALID_CPF
			});
			return false;
		}
		return true;
	},
	isCpfValid: function isCpfValid() {
		var cpf = this.state.value || '';
		var digitsOnly = cpf.replace(/\D/g, '');
		if (digitsOnly.length === 11) {
			return true;
		}
		return false;
	},
	render: function render() {
		if (!this.state.showGuestCPF) {
			return null;
		}

		var errorMessage = this.getErrorMessage();
		var wrapperClassNames = (0, _classnames2.default)({
			'vx_has-error-with-message': errorMessage,
			'vx_has-error': !!errorMessage
		});

		return _react2.default.createElement(
			'div',
			{ className: wrapperClassNames },
			_react2.default.createElement(_reactTextInput2.default, {
				name: 'cpf',
				id: 'cpf',
				className: 'vx_form-control vx_form-control_complex',
				label: this.props.label,
				required: this.props.required,
				value: this.state.value,
				handleChange: this.handleChange,
				onFocus: this.handleFocus,
				handleFocus: this.handleFocus,
				onBlur: this.handleBlur,
				handleBlur: this.handleBlur
			}),
			_react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.errorMessage, errorMessage && styles.errorShown), {
						'vx_form-control-message': errorMessage
					}) },
				errorMessage
			)
		);
	}
});

exports.default = Cpf;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/Cpf.js
// module id = 537
// module chunks = 4